import { render, staticRenderFns } from "./edit-b2b-price.vue?vue&type=template&id=a9e6aaee&scoped=true&"
import script from "./edit-b2b-price.vue?vue&type=script&lang=js&"
export * from "./edit-b2b-price.vue?vue&type=script&lang=js&"
import style0 from "./edit-b2b-price.vue?vue&type=style&index=0&id=a9e6aaee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e6aaee",
  null
  
)

export default component.exports